import './components/CookieBar'
import './components/DynamicForm'
import './components/FAQ'
import './components/ImageSlider'
import './components/Kennisbank'
import './components/Lightbox'

addEventListener('DOMContentLoaded', () => {
	initializeMenu()
	initializeScrolling()
	initializeHeroQuotes()
})

function initializeMenu() {
	const header = document.querySelector('header')

	const hamburger = document.getElementById('hamburger-toggle')
	hamburger?.addEventListener('click', () => {
		document.body.classList.toggle('menu-open')

		if (document.body.classList.contains('menu-open')) {
			window.scrollTo?.({
				behavior: 'smooth',
				top: 0,
			})
		}
	})

	// Allow double tapping for mobile users.
	const parentItems = header.querySelectorAll('li.has-children > a, #languages div.dropdown')
	for (let a = 0; a < parentItems.length; a++) {
		parentItems[a].addEventListener('click', function (event) {
			if (event.pointerType === 'touch') {
				if (!this.active) {
					event.preventDefault()
				}
				this.active = true
			}
		})

		parentItems[a].addEventListener('mouseleave', function (event) {
			this.active = false
		})
	}
}

function initializeScrolling() {
	function scroll() {
		const y = window.scrollY || window.pageYOffset
		if (y > 100 && !document.body.classList.contains('scrolled')) {
			document.body.classList.add('scrolled')
		}
		else if (y <= 100 && document.body.classList.contains('scrolled')) {
			document.body.classList.remove('scrolled')
		}
	}

	addEventListener('scroll', scroll)
	scroll()
}

// Quote 'carousel' in the hero.
function initializeHeroQuotes() {
	const container = document.querySelector('ui-carousel .quotes')
	if (!container) {
		return
	}

	const quotes = container.querySelectorAll('p')
	const TIMEOUT = 10_000 // 20_000
	let currentIndex = 0
	let interval = null

	const showQuote = (index) => {
		for (let a = 0; a < quotes.length; a++) {
			if (a === index) {
				quotes[a].classList.add('visible')
			}
			else {
				quotes[a].classList.remove('visible')
			}

			if (a === index - 1 || (a === quotes.length - 1 && index == 0)) {
				quotes[a].classList.add('prev')
			}
			else {
				quotes[a].classList.remove('prev')
			}
		}
		currentIndex = index
	}

	const stopInterval = () => clearInterval(interval)

	const startInterval = () => {
		stopInterval()
		interval = setInterval(function () {
			const next = (currentIndex + 1) % quotes.length
			showQuote(next)
		}, TIMEOUT)
	}

	startInterval()
	showQuote(0)
}